import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_zombie-headquarters/artifacts/po73nh7b_IMG_0934.webp",
  room: "https://static.prod-images.emergentagent.com/jobs/b7e02ecc-52dc-4eba-b5b5-7ba736a2da1f/images/f1010597d2eb8ac4cef975c3f583f49f84d21db94eb175149a1618162b8542bf.png",
  entrance: "https://static.prod-images.emergentagent.com/jobs/b7e02ecc-52dc-4eba-b5b5-7ba736a2da1f/images/5304aeb46cb851389bbca0b0bdaa056120b65038967add0c0f10a6a3f39c2034.png",
  cork: "https://images.unsplash.com/photo-1517430970194-f92273690924",
  letter: "https://images.unsplash.com/photo-1662748901039-e088768dc073",
  typewriter: "https://images.unsplash.com/photo-1530819568329-97653eafbbfa",
  magnifier: "https://images.unsplash.com/photo-1762180980045-4d7c5a6c0fc9",
};
